import React from 'react';
import Modal from 'shared/components/modal';
import {AdminAccessOrganization} from 'src/services/AdminAccessOrganizationService';

interface Props {
  organization: AdminAccessOrganization | null;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteOrganizationConfirmationModal = ({organization, onConfirm, onCancel}: Props) => (
  <Modal show={!!organization} onClose={onCancel}>
    <Modal.TextHeader onClose={onCancel}>Delete Access Organization?</Modal.TextHeader>
    <Modal.Body>
      <p>
        Are you sure you want to delete <strong>{organization?.name}</strong>? This action cannot be
        undone.
      </p>
    </Modal.Body>
    <Modal.Footer
      primaryButton={{
        text: 'Delete',
        onClick: onConfirm,
        'aria-label': 'Delete access organization',
      }}
      secondaryButton={{
        text: 'Cancel',
        onClick: onCancel,
      }}
    />
  </Modal>
);

export default DeleteOrganizationConfirmationModal;
